'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var reactIntersectionObserver = require('react-intersection-observer');
var ViewportConfigProvider = require('../../providers/ViewportConfigProvider.js');
var theme = require('../../consts/theme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const FooterWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-imlrid-0"
})(["width:100%;", ""], _ref => {
  let {
    removePadding
  } = _ref;
  return removePadding ? `
    & footer > nav {
      padding: 0;
    }
  ` : '';
});
const InlineContainer = styled__default["default"].div.withConfig({
  componentId: "sc-imlrid-1"
})([""]);
const AbsoluteContainer = styled__default["default"].div.withConfig({
  componentId: "sc-imlrid-2"
})(["position:absolute;z-index:", ";bottom:", "px;left:", "px;right:", "px;", ";"], theme.zIndex.AppBar, _ref2 => {
  let {
    offsetBottom
  } = _ref2;
  return offsetBottom ?? 0;
}, _ref3 => {
  let {
    offsetLeft
  } = _ref3;
  return offsetLeft ?? 0;
}, _ref4 => {
  let {
    offsetRight
  } = _ref4;
  return offsetRight ?? 0;
}, _ref5 => {
  var _theme$documentbodyNo, _theme$panelcontainer, _theme$panelcontainer2, _theme$panelcontainer3;
  let {
    theme
  } = _ref5;
  return {
    ...theme.documentbodyNoneNone,
    backgroundColor: ((_theme$documentbodyNo = theme.documentbodyNoneNone) === null || _theme$documentbodyNo === void 0 ? void 0 : _theme$documentbodyNo.backgroundColor) ?? '#fff',
    borderTopColor: ((_theme$panelcontainer = theme.panelcontainerNoneNone) === null || _theme$panelcontainer === void 0 ? void 0 : _theme$panelcontainer.borderTopColor) || '#ccc',
    borderTopWidth: ((_theme$panelcontainer2 = theme.panelcontainerNoneNone) === null || _theme$panelcontainer2 === void 0 ? void 0 : _theme$panelcontainer2.borderTopWidth) || '1px',
    borderTopStyle: ((_theme$panelcontainer3 = theme.panelcontainerNoneNone) === null || _theme$panelcontainer3 === void 0 ? void 0 : _theme$panelcontainer3.borderTopStyle) || 'solid'
  };
});
const StickyContainer = styled__default["default"].div.withConfig({
  componentId: "sc-imlrid-3"
})(["position:fixed;z-index:", ";bottom:", "px;left:", "px;right:", "px;", ";"], theme.zIndex.AppBar, _ref6 => {
  let {
    offsetBottom
  } = _ref6;
  return offsetBottom ?? 0;
}, _ref7 => {
  let {
    offsetLeft
  } = _ref7;
  return offsetLeft ?? 0;
}, _ref8 => {
  let {
    offsetRight
  } = _ref8;
  return offsetRight ?? 0;
}, _ref9 => {
  var _theme$documentbodyNo2, _theme$panelcontainer4, _theme$panelcontainer5, _theme$panelcontainer6;
  let {
    theme
  } = _ref9;
  return {
    ...theme.documentbodyNoneNone,
    backgroundColor: ((_theme$documentbodyNo2 = theme.documentbodyNoneNone) === null || _theme$documentbodyNo2 === void 0 ? void 0 : _theme$documentbodyNo2.backgroundColor) ?? '#fff',
    borderTopColor: ((_theme$panelcontainer4 = theme.panelcontainerNoneNone) === null || _theme$panelcontainer4 === void 0 ? void 0 : _theme$panelcontainer4.borderTopColor) || '#ccc',
    borderTopWidth: ((_theme$panelcontainer5 = theme.panelcontainerNoneNone) === null || _theme$panelcontainer5 === void 0 ? void 0 : _theme$panelcontainer5.borderTopWidth) || '1px',
    borderTopStyle: ((_theme$panelcontainer6 = theme.panelcontainerNoneNone) === null || _theme$panelcontainer6 === void 0 ? void 0 : _theme$panelcontainer6.borderTopStyle) || 'solid'
  };
});
const StickyFooter = _ref10 => {
  let {
    absolute,
    fixed,
    removePadding,
    onShow,
    children
  } = _ref10;
  const viewportConfig = ViewportConfigProvider.useViewportConfig();
  const {
    ref,
    inView
  } = reactIntersectionObserver.useInView({
    threshold: 0
  });
  const inline = inView && !fixed && !absolute;
  React.useEffect(() => {
    onShow === null || onShow === void 0 ? void 0 : onShow({
      inView,
      display: inline ? 'inline' : 'footer'
    });
  }, [inView, inline, onShow]);
  return /*#__PURE__*/React__default["default"].createElement(FooterWrapper, {
    removePadding: removePadding === 'always' || removePadding === 'inline' && inline || removePadding === 'footer' && !inline,
    ref: ref
  }, inline && /*#__PURE__*/React__default["default"].createElement(InlineContainer, null, children), absolute && /*#__PURE__*/React__default["default"].createElement(AbsoluteContainer, viewportConfig.anchor, children), !inline && !absolute && /*#__PURE__*/React__default["default"].createElement(StickyContainer, viewportConfig.anchor, children));
};

exports["default"] = StickyFooter;
